import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AmountAggregator  {
    _originalTypeClassName = "zERP.BO.AmountAggregator";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AmountAggregator.translate = translateService;
}
this.BO = new Domain.AccountingSystemEntity();
this.Parts = [];
this.Id = null;
this.Name = null;
this.Description = null;
this.Enabled = false;
this.ValueType = null;
this.UpdateFrequency = null;
this.Priority = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Description:any;
Enabled:any;
ValueType:any;
UpdateFrequency:any;
Priority:any;
BO:any;
Parts:any;
AggregationProcess:any;
static setBO = ($this, value) => {
var oldValue = $this.BO;
$this.BO = value;
if (value != null) {
}
}
static setParts = ($this, items) => {
                if (items == null) items = [];
                if ($this.Parts == null) $this.Parts = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Parts.length > 0) {
                    Domain.AmountAggregator.removeParts($this, $this.Parts[0]);
                }

                Domain.AmountAggregator.addManyParts($this, copyItems);
            }
static addManyParts = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.AmountAggregator.addParts($this, items[i]);
                }
            }
static addParts = ($this, item) => {
                if ($this.Parts == null) $this.Parts = [];
                if (item == null || $this.Parts.indexOf(item) > -1) return;
                $this.Parts.push(item);
}
static addRangeParts = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.AmountAggregator.addParts($this, item));
            }
static removeParts = ($this, item) => {
                if ($this == null || $this.Parts == null || $this.Parts.indexOf(item) === -1) return;
                var _index = $this.Parts.indexOf(item);
                $this.Parts.splice(_index, 1);
}
static clearParts = ($this) => { $this.Parts = null; }
static setAggregationProcess = ($this, value) => {
var oldValue = $this.AggregationProcess;
$this.AggregationProcess = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}